import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelRomanian: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'B',
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: '©',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: 'Đ',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
  },
  {
    code: 10,
    label: 'G',
  },
  {
    code: 11,
    label: 'H',
  },
  {
    code: 12,
    label: 'I',
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: 'Ł',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'N',
  },
  {
    code: 18,
    label: 'O',
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 20,
    label: 'Q',
  },
  {
    code: 21,
    label: 'R',
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
  },
  {
    code: 24,
    label: 'U',
  },
  {
    code: 25,
    label: 'V',
  },
  {
    code: 26,
    label: 'W',
  },
  {
    code: 27,
    label: 'X',
  },
  {
    code: 28,
    label: 'Y',
  },
  {
    code: 29,
    label: 'Z',
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '@',
        modifiers: MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: 'ˇ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '^ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˘ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '° (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '^',
        modifiers: MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˛ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˙ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '–',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '–',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¸ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '±',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'Ă',
    meta: [
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '{',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: 'Î',
    meta: [
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '}',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: 'Â',
  },
  {
    code: 51,
    label: 'Ș',
  },
  {
    code: 52,
    label: 'Ț',
    meta: [
      {
        label: "'",
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '"',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '„',
    meta: [
      {
        label: '”',
        modifiers: MOD.SFT,
      },
      {
        label: '”',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '`',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '~',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: ';',
        modifiers: MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '«',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '«',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '»',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.ALT,
      },
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: '/',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 100,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '@',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '^',
  },
  {
    code: 548,
    label: '&',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '_',
  },
  {
    code: 558,
    label: '+',
  },
  {
    code: 565,
    label: '”',
  },
  {
    code: 566,
    label: ';',
  },
  {
    code: 567,
    label: ':',
  },
  {
    code: 568,
    label: '?',
  },
  {
    code: 612,
    label: '|',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '@',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '^',
  },
  {
    code: 4644,
    label: '&',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '_',
  },
  {
    code: 4654,
    label: '+',
  },
  {
    code: 4661,
    label: '”',
  },
  {
    code: 4662,
    label: ';',
  },
  {
    code: 4663,
    label: ':',
  },
  {
    code: 4664,
    label: '?',
  },
  {
    code: 4708,
    label: '|',
  },
  {
    code: 5126,
    label: '©',
  },
  {
    code: 5127,
    label: 'Đ',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5135,
    label: 'Ł',
  },
  {
    code: 5139,
    label: '§',
  },
  {
    code: 5142,
    label: 'ß',
  },
  {
    code: 5150,
    label: '~ (dead)',
  },
  {
    code: 5151,
    label: 'ˇ (dead)',
  },
  {
    code: 5152,
    label: '^ (dead)',
  },
  {
    code: 5153,
    label: '˘ (dead)',
  },
  {
    code: 5154,
    label: '° (dead)',
  },
  {
    code: 5155,
    label: '˛ (dead)',
  },
  {
    code: 5156,
    label: '` (dead)',
  },
  {
    code: 5157,
    label: '˙ (dead)',
  },
  {
    code: 5158,
    label: '´ (dead)',
  },
  {
    code: 5159,
    label: '˝ (dead)',
  },
  {
    code: 5165,
    label: '¨ (dead)',
  },
  {
    code: 5166,
    label: '¸ (dead)',
  },
  {
    code: 5167,
    label: '[',
  },
  {
    code: 5168,
    label: ']',
  },
  {
    code: 5172,
    label: "'",
  },
  {
    code: 5173,
    label: '`',
  },
  {
    code: 5174,
    label: '<',
  },
  {
    code: 5175,
    label: '>',
  },
  {
    code: 5677,
    label: '–',
  },
  {
    code: 5677,
    label: '–',
  },
  {
    code: 5678,
    label: '±',
  },
  {
    code: 5678,
    label: '±',
  },
  {
    code: 5679,
    label: '{',
  },
  {
    code: 5679,
    label: '{',
  },
  {
    code: 5680,
    label: '}',
  },
  {
    code: 5680,
    label: '}',
  },
  {
    code: 5684,
    label: '"',
  },
  {
    code: 5684,
    label: '"',
  },
  {
    code: 5685,
    label: '~',
  },
  {
    code: 5685,
    label: '~',
  },
  {
    code: 5686,
    label: '«',
  },
  {
    code: 5686,
    label: '«',
  },
  {
    code: 5687,
    label: '»',
  },
  {
    code: 5687,
    label: '»',
  },
];
